import React, {Component} from 'react';
import {Modal, NavBar, Toast,} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import {walletBalance, walletMessagesend, walletSign,ysfSign} from "../../../../service/homeService";
import TestCode from '../../../../components/TestCode'
const ysf = require('../../../../common/image/ysf.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            balance:"---",
            codeModal:false,
            getCodeDisabled: false,
            getCodeText: '重新获取',
            smsSendNo:"",
            ysfModal:false,
        };
    }
    componentDidMount(){
        walletBalance({token:this.props.userInfo.token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({balance:res.data.data.balance,})
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    onClose = () => {
        this.setState({codeModal:false});
    };
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    signClick(){
        if(this.state.getCodeText == "重新获取"){
            this.getCode()
        }else {
            Toast.info(this.state.getCodeText,3)
        }
    }
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
        };
        walletMessagesend(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setDownTime(60);
                this.setState({codeModal:true,smsSendNo:res.data.data.smsSendNo});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        let params ={
            token:this.props.userInfo.token,
            source:1,
            data:{
                smsSendNo:this.state.smsSendNo,
                smsCode:v,
            },
        };
        console.log(params,v);
        // return
        Toast.loading("",0);
        walletSign(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({getCodeText: '重新获取'});
                Toast.info('签约成功',2,()=>{
                    this.props.history.goBack();
                    this.setState({codeModal:false});
                })
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    reserve(){
        let params ={
            token:this.props.userInfo.token,
            source:1,
        };
        Toast.loading("",0);
        ysfSign(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.info('签约成功',2,()=>{
                    this.props.history.goBack();
                    this.setState({ysfModal:false});
                })
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    render(){
        return(
            <div className="account">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                    rightContent={
                        this.props.location.state.signStatus == 0 ? <button className="sign" onClick={()=>this.signClick()}>账户签约</button> : null
                    }
                >账户</NavBar>
                <div className="content">
                    <div className="top">
                        <div className="topText">
                            <div className="money">
                                <p>账户余额</p>
                                <p className="num">{'￥'+ this.state.balance}</p>
                            </div>
                            <div className="minxi" onClick={()=>this.props.history.push(`/accountInfo`)}>交易明细</div>
                        </div>
                    </div>
                    <div className="listBox" onClick={()=>this.props.history.push(`/recharge`,{type:"recharge",balance:this.state.balance})}>
                        <div>
                            <i className="icon iconfont iconzhanghuchongzhi"/>
                            <span>充值</span>
                        </div>
                        <i className="icon iconfont icontiaozhuan2"/>
                    </div>
                    <div className="listBox" onClick={()=>this.props.history.push(`/recharge`,{type:"out",balance:this.state.balance})}>
                        <div>
                            <i className="icon iconfont iconzhanghutixian"/>
                            <span>提现</span>
                        </div>
                        <i className="icon iconfont icontiaozhuan2"/>
                    </div>
                    <div className="listBox lists" onClick={()=>this.props.history.push(`/bankCard`)}>
                        <div>
                            <i className="icon iconfont iconyinhangkaguanli"/>
                            <span>银行卡管理</span>
                        </div>
                        <i className="icon iconfont icontiaozhuan2"/>
                    </div>
                    {
                        this.props.location.state.bindStatus == 0 ? (
                            <div className="listBox " onClick={()=>this.setState({ysfModal:true})}>
                                <div>
                                    <img src={ysf}/>
                                    <span>开通云闪付</span>
                                </div>
                                <i className="icon iconfont icontiaozhuan2"/>
                            </div>
                        ):null
                    }

                </div>
                <Modal
                    className="ysfModal"
                    visible={this.state.ysfModal}
                    transparent
                    closable={true}
                    maskClosable={false}
                    onClose={()=>this.setState({ysfModal:false})}
                    footer={[{text: '确认签约', onPress: () => this.reserve()}]}
                >
                    <div >
                        <div>云闪付App一键绑卡用户授权协议</div>
                        《云闪付App一键绑卡用户授权协议》（以下简称“本协议”）是工商银行云南省分行（以下简称“工商银行”）与用户（以下简称“您”）所订立的有效合约。在接受本协议前，您应仔细阅读本协议项下全部内容，并对加粗字体显示部分重点阅读。本协议的效力基于工银卡在本协议项下为您提供的一切服务。<br/>
                        1、您确认，您同意接受本协议时，您具有完全民事权利能力和民事行为能力，能够独立承担民事责任；本协议内容不受您所属国家或地区法律排斥。如您不具备前述条件或无法同意本协议的任意内容，请勿进行后续操作，并立即停止授权。<br/>
                        2、您确认，您接受本协议并确认授权后，即视为您同意并授权将您的工银卡相关信息及数据传递给中国银联。授权页面会展示具体授权对象、授权信息等，授权信息通过加密通道传递给中国银联。中国银联可以使用由您同意并授权的、工商银行收集并转交的个人信息（包括但不限于姓名、工银卡卡号、证件类型及号码、手机号码等信息）并进行核对校验。核对校验通过后，若您已是云闪付App用户，中国银联可以将您授权的工银卡自动绑定至您手机号所匹配已开通的您在云闪付App的支付账户（以下简称“支付账户”）中，以便于您在使用支付账户时可以通过该卡进行快捷支付；若您尚未成为云闪付App用户，中国银联将以您的手机号作为云闪付App的用户名，为您注册云闪付App账号。工商银行会要求中国银联依法使用您所授权的信息，并应对您的信息保密。<br/>
                        3、您理解，中国银联提供的服务由中国银联独立运营，并承担全部责任。如中国银联的站点或软件存在漏洞、故障、病毒等原因造成您的相关权益受损；或其使用您的信息产生的纠纷；或中国银联提供的服务违反相关法律法规或本协议约定，您可以请中国银联协调，但您不应就以上问题和登录、使用中国银联的站点或软件造成的后果要求工商银行承担任何责任。<br/>
                        4、您同意，工商银行有权根据业务发展需要对本协议的内容予以变更，并在用户授权页面展示，无需另行单独通知您。变更后的协议内容一经公布，即代替原来的协议内容，您须定期审阅本协议及变更后的内容。<br/>
                        5、本协议未尽事宜，参照《银联用户服务协议》执行；《银联用户服务协议》与本协议有冲突的，以本协议为准。<br/>
                        6、因本协议产生任何争议，双方应友好协商解决；协商不成，任何一方有权向被告住所地有管辖权的人民法院提起诉讼。<br/>

                    </div>
                </Modal>
                <TestCode
                    modal={this.state.codeModal}
                    onClose={this.onClose.bind(this)}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/Account/index.js